export default __webpack_public_path__ + "static/media/39.abb255a5.jpg";